import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import TabElement from "../../../Components/UiComponents/TabElement";
import { getCustomerFields } from "../../../Services/customerServices";
import ChangePassword from "./ChangePassword/ChangePasword";
import { getCustomer } from "../../../Services/customerServices";
import { getModulePermissions } from "../../../Services/pricingPlanService";
import UsersTimesheet from "./UsersTimesheet/UsersTimesheet";
import EmailNotifications from "./EmailNotifications/EmailNotifications";
import Timesheet from "./Timesheet/Timesheet";
import ToastElement from "../../../Components/UiComponents/ToastElement";
import { useNavigate } from "react-router-dom";
import PlaylistVideos from "../../../Components/Videos/PlaylistVideos";
import { Dialog } from "primereact/dialog";
import ButtonElement from "../../../Components/UiComponents/ButtonElement";

const MyAccount = () => {
    const [items, setItems] = useState([]);
    const [customerId, setCustomerId] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [pricingPlan, setPricingPlan] = useState("");
    const [tabPermissions, setTabPermissions] = useState({});
    const [showVideo, setShowVideo] = useState(false);
    const navigate = useNavigate()
    const toastRef = useRef();

    var enduser = localStorage.getItem("enduser")
    if (enduser) {
        var tmpData = JSON.parse(enduser);
        if (tmpData === null) {
            navigate("/login")
            localStorage.clear()
        }
    }

    useEffect(() => {
        const customerData = localStorage.getItem("enduser");
        if (customerData) {
            const customerDataInJSON = JSON.parse(customerData);
            setCustomerId(customerDataInJSON.customer);
        } else {
            navigate("/login")
            localStorage.clear()
        }
    }, []);

    useEffect(() => {
        if (customerId) {
            getCustomerDetails();
        }
    }, [customerId]);

    useEffect(() => {
        if (pricingPlan) {
            getModulePermission();
        }
    }, [pricingPlan])

    useEffect(() => {
        if (tabPermissions && customerId) {
            getTabDetails();
        }
    }, [tabPermissions, customerId])

    const getCustomerDetails = async () => {
        try {
            if (customerId === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            var customerDataResponse = await getCustomer(customerId);
            if (customerDataResponse && customerDataResponse.data) {
                setPricingPlan(customerDataResponse.data.pricing_plan);
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    }

    const getModulePermission = async () => {
        try {
            if (pricingPlan) {
                const res = await getModulePermissions(pricingPlan, "My Account");

                if (res && res.data) {
                    const modulePermissions = res.data;
                    if (modulePermissions.status && modulePermissions.sub_modules) {
                        var tabPermissions = {};
                        _.filter(modulePermissions.sub_modules, (sub_module) => {
                            tabPermissions[sub_module.module_name] = sub_module.status;
                        });
                        setTabPermissions(tabPermissions);
                    }
                }
            } else {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Pricing Plan Data is not fetched'
                });
                return;
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    }

    const getTabDetails = async () => {
        try {
            if (customerId === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            const response = await getCustomerFields(customerId);
            if (response && response.data) {
                var myAccountModules = _.find(response.data.cust[0].modules, { module_name: "My Account", status: true });
                var newItems = [];

                var tabs = [
                    {
                        label: myAccountModules.sub_modules[0].display_name,
                        icon: "pi pi-key",
                        Component: (
                            <ChangePassword />
                        ),
                    },
                    {
                        label: myAccountModules.sub_modules[1].display_name,
                        icon: "pi pi-calendar-clock",
                        Component: (
                            <Timesheet />
                        ),
                    },
                    {
                        label: myAccountModules.sub_modules[2].display_name,
                        icon: "pi pi-users",
                        Component: (
                            <UsersTimesheet />
                        ),
                    },
                    {
                        label: myAccountModules.sub_modules[3].display_name,
                        icon: "pi pi-envelope",
                        Component: (
                            <EmailNotifications />
                        ),
                    }
                ]

                if (tabPermissions["Change Password"]) {
                    newItems.push(tabs[0]);
                }
                if (tabPermissions["Timesheet"]) {
                    newItems.push(tabs[1]);
                }
                if (tabPermissions["Users Timesheet"] && (tmpData.isAdmin || tmpData.isBranchAdmin)) {
                    newItems.push(tabs[2]);
                }
                if (tabPermissions["Email Notification"]) {
                    newItems.push(tabs[3]);
                }
                setItems(newItems)
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    }

    const updates = (e) => {
        setActiveIndex(e.index);
    };

    const handleButtonClick = () => {
        setShowVideo(true);
    };

    const closeVideo = () => {
        setShowVideo(false);
    };

    return (
        <div className="form-group row align-items-center mb-0 mt-0">
            <ToastElement ref={toastRef} />
            <div className="col-md-12 mt-2 text-right">
                <ButtonElement className="upload-button" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
            </div>
            <div className="col pr-0 pl-0">
                <div className="portfolio-tabs">
                    <TabElement
                        items={items}
                        activeIndex={activeIndex}
                        onTabChange={(e) => updates(e)}
                        mainModules={false}
                    />
                </div>
            </div>
            <Dialog id="videoModal" visible={showVideo}
                breakpoints={{
                    '1200px': '80vw',    // Larger modal on bigger screens
                    '1024px': '85vw',    // Slightly smaller for medium screens
                    '769': '90vw',     // Responsive on tablets
                    '641px': '95vw',     // Almost full-width on mobile
                }}
                modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
            >
                <div className="video-overlay">
                    <div className="video-container">
                        <PlaylistVideos playlistId={process.env.REACT_APP_MAIN_MODULES_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="myaccount" />
                    </div>
                </div>
            </Dialog>
        </div>
    )
}

export default MyAccount